import instance from '../config/axios';

export const setPasswordByAdmin = async (
  password: string,
  patientId: number,
  access_token: string,
) =>
  await instance.put(
    '/api/v1/patient/reset/password/admin',
    {
      password,
      patientId: patientId,
    },
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );
